import { useQuery } from '@tanstack/react-query'
import { Alert } from 'antd'
import React from 'react'
import { refundQueries } from '../../../../../Actions'
import RefundLedgerTable from './RefundLedgerTable'

type Props = {
  workspaceId: number
  /** 결제 건 목록의 `기록 보기` 가 지목한 행 */
  highlightRefundId?: number | null
}

/**
 * 환불대장 섹션 (aipark-front #266 P1·P3)
 *
 * 정렬·경과일·사건 묶음·불일치 판정을 서버가 다 해서 내린다. 이 섹션이 하는 일은 렌더와
 * 필터, 그리고 상세 서랍에서의 상태 전이(P3)뿐이다.
 */
export default function Refunds({ workspaceId, highlightRefundId }: Props) {
  const { isLoading, data, error } = useQuery({ ...refundQueries.ledger(workspaceId) })

  if (error) {
    return (
      <Alert
        type="error"
        showIcon
        style={{ marginBottom: 20 }}
        message="환불대장을 불러오지 못했습니다"
        description={(error as any)?.message ?? String(error)}
      />
    )
  }

  return (
    <RefundLedgerTable
      rows={data ?? []}
      workspaceId={workspaceId}
      loading={isLoading}
      highlightRefundId={highlightRefundId}
    />
  )
}
